
import { Form, Field, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { Component } from 'react'
import { FormGroup, Row, Col} from 'reactstrap';
import handleSubmit from './handleSubmit';

export default class SignUpForm extends Component {
  validationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup
      .string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters").oneOf([Yup.ref("passwordConfirmation"), null], "Passwords must match"),
    passwordConfirmation: Yup
      .string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match")
  })
  render() {
    return (
     
            <Formik
              initialValues={{ email: "", password: "", passwordConfirmation: "", firstName: "", lastName: "" }}
              onSubmit={handleSubmit}
              validationSchema={this.validationSchema}
            >
              {() => (<Form className="form-container">
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Field type="text" name="firstName" className={"form-control"} placeholder="First Name" />
                    <ErrorMessage style={{color:"red"}} component="div"  name='firstName' />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Field type="text" name="lastName" className={"form-control"} placeholder="Last Name" />
                    <ErrorMessage style={{color:"red"}}  name='lastName' component="div" />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup>
                  <Field type="text" name="email" className={"form-control"} placeholder="Email" />
                <ErrorMessage style={{color:"red"}} name='email' component="div"  />
                </FormGroup>
                <FormGroup>
                  <Field type="password" name="password" className={"form-control"} placeholder="Password" />
                </FormGroup><FormGroup>
                  <Field type="password" name="passwordConfirmation" className={"form-control"} placeholder="Password Confirmation" />
                <ErrorMessage style={{color:"red"}} name='password' component="div"  /> </FormGroup>
                <button type="submit" className="btn btn-primary">Sign Up</button>
              </Form>)}
            </Formik>
         
  
    )
  }
}
